"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.translateLogo = exports.translateSchemaObject = exports.convertSchema = void 0;
var index_1 = require("./schema/index");
Object.defineProperty(exports, "convertSchema", { enumerable: true, get: function () { return index_1.convertSchema; } });
Object.defineProperty(exports, "translateSchemaObject", { enumerable: true, get: function () { return index_1.translateSchemaObject; } });
var translateLogo_1 = require("./translateLogo");
Object.defineProperty(exports, "translateLogo", { enumerable: true, get: function () { return translateLogo_1.translateLogo; } });
//# sourceMappingURL=index.js.map